import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from "@monbits/ui";
import type * as React from "react";

interface Props {
	open: boolean;
	onOpenChange: (open: boolean) => void;
}

const ChatIdHelpDialog: React.FC<Props> = ({ open, onOpenChange }) => (
	<Dialog open={open} onOpenChange={onOpenChange}>
		<DialogContent>
			<DialogHeader>
				<DialogTitle>Finding your chat ID</DialogTitle>
				<DialogDescription>
					Three steps, using just Telegram and your browser.
				</DialogDescription>
			</DialogHeader>
			<ol className="space-y-4 text-sm">
				<li className="flex gap-3">
					<span className="font-semibold text-muted-foreground">1.</span>
					<span>
						Add your bot to the chat or channel you want notifications in, or
						start a direct conversation with it.
					</span>
				</li>
				<li className="flex gap-3">
					<span className="font-semibold text-muted-foreground">2.</span>
					<span>Send any message in that chat.</span>
				</li>
				<li className="flex gap-3">
					<span className="font-semibold text-muted-foreground">3.</span>
					<span>
						In your browser, open{" "}
						<code className="rounded bg-muted px-1.5 py-0.5 text-xs break-all">
							https://api.telegram.org/bot&lt;YOUR_TOKEN&gt;/getUpdates
						</code>{" "}
						— replace <code className="text-xs">&lt;YOUR_TOKEN&gt;</code> with
						your bot token. Look for{" "}
						<code className="text-xs">"chat":&#123;"id":</code> — that number is
						your chat ID. Group and channel IDs are negative.
					</span>
				</li>
			</ol>
		</DialogContent>
	</Dialog>
);

export default ChatIdHelpDialog;
